module.exports = __webpack_public_path__ + "app/principal/principal-export-config-1EIBhzWk.html";